import React, {useEffect, useState} from 'react';
import {Flex, Image} from "antd";
import Header from "../components/Header/Header";
import {clrs} from "../../constants/colors";
import video from '../../images/video.mov';
import xxx_ver from '../../images/xx_ver@3x.png';
import xxx_hor from '../../images/xx_hor@3x.png';
import right from '../../images/arrow_right_white@3x.png';
import dots from '../../images/dots_white@3x.png';
import lines from '../../images/lines@3x.png';
import under1 from '../../images/under1@3x.png';
import under2 from '../../images/under2@3x.png';
import under3 from '../../images/under3@3x.png';
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import OrangeButton from "../../components/UI/Buttons/OrangeButton";
import TransparentButton from "../../components/UI/Buttons/TransparentButton";
import {RightCircleFilled} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {Fade} from "react-awesome-reveal";

const HomePage = () => {

    return (
        <Flex style={{width: "100%", minHeight: "100vh", position: "relative", overflow: "hidden"}} vertical align={"center"} justify={"flex-start"}>
            {/*<TypingTextEffect  texts={[ 'Подготовка к ент', 'Диас хахах 1111', 'Батырбек авыаро ывоарыв', ]} speed={10} />*/}
            {/*<BrainBrew/>*/}
            {/*<BrainBrewAcademy/>*/}

            <Flex style={{width: "100%", minHeight: "100%", position: "absolute"}}>
                <video style={{width: "100%", minHeight: "100%"}} autoPlay loop muted>
                    <source src={video} type='video/mp4'/>
                </video>
                <div style={{width: "100%", height: "100%", position: "absolute", backgroundColor: clrs.blackerBlue3, opacity: 0.6}}></div>
            </Flex>
            <Image preview={false} src={xxx_ver} width={30} wrapperStyle={{position: "absolute", top: 200, left: "50%", transform: "translateX(-800px)"}}/>
            <Image preview={false} src={xxx_hor} width={80} wrapperStyle={{position: "absolute", top: 700, left: "50%", transform: "translateX(300px)"}}/>
            <Image preview={false} src={right} width={80} wrapperStyle={{position: "absolute", top: 200, left: "50%"}}/>
            <Image preview={false} src={dots} width={80} wrapperStyle={{position: "absolute", top: 200, left: "50%", transform: "translateX(400px)"}}/>
            <Image preview={false} src={dots} width={80} wrapperStyle={{position: "absolute", top: 700, left: "50%"}}/>
            <Header/>
            <Flex style={{width: "100%", maxWidth: 1440, minHeight: "calc(100vh - 350px)", position: "relative", paddingTop: 350}} gap={100} vertical>
                <Banner/>
                <Buttons/>
                <Under/>
            </Flex>

        </Flex>
    );
};

const Banner = () => {
    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"center"} vertical>
            <Fade triggerOnce cascade>
                <p style={{fontSize: "3rem", color: "white", fontWeight: 100, lineHeight: "2rem"}}><IntlMessage
                    id={'homePage.bannerText1'}/></p>
                <p style={{
                    fontSize: "4rem",
                    color: "white",
                    fontWeight: 900,
                    transform: "translateX(-4px)",
                    lineHeight: "3rem"
                }}>
                    <Flex align={"center"} justify={"center"} style={{fontWeight: 700}}>
                        <IntlMessage id={'homePage.bannerText2'}/>
                        <Image preview={false} width={180} src={lines} style={{transform: "translateY(3px)"}}/>
                    </Flex>
                </p>
                <p style={{
                    fontSize: "7rem",
                    color: "transparent",
                    "-webkit-text-stroke": "2px white",
                    transform: "translateX(-9px)",
                    lineHeight: "6rem",
                    fontWeight: 700
                }}><IntlMessage id={'homePage.bannerText3'}/></p>

            </Fade>
        </Flex>
    )
}
const Buttons = () => {
    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={30}>
            <Fade triggerOnce cascade delay={1500}>
                <Link to={'/monitoring'}>
                    <OrangeButton>
                        <Flex align={"center"} justify={"center"} gap={10}>
                            <IntlMessage id={'homePage.monitoring'}/>
                            <RightCircleFilled/>
                        </Flex>
                    </OrangeButton>
                </Link>
                <Link to={'/about'}>
                    <TransparentButton>
                        <IntlMessage id={'homePage.details'}/>
                    </TransparentButton>
                </Link>
            </Fade>

        </Flex>
    )
}

const Under = () => {
    return (
        <Flex style={{
            width: "100%",
            maxWidth: 1000,
            bottom: 0,
            left: 0,
            position: "absolute",
            padding: 25,
            minHeight: 100, backgroundColor: "white", zIndex: 100}} align={"center"} justify={"center"} gap={50}>
            <Flex style={{width: 300}} align={"center"} justify={"center"} gap={20}>
                <Image src={under1} preview={false} width={40}/>
                <Flex vertical align={"flex-start"} justify={"center"}>
                    <Flex gap={5} align={"flex-end"} justify={"center"}>
                        <span style={{color: clrs.orange, fontWeight: 700, transform: "translateY(-5px)"}}><IntlMessage id={'homePage.under.1.header1'}/></span>
                        <span style={{color: clrs.blacker, fontWeight: 700, fontSize: "2rem"}}><IntlMessage id={'homePage.under.1.header2'}/></span>
                    </Flex>
                    <p style={{fontWeight: 700, fontSize: "0.7rem", width: 240}}>
                        <IntlMessage id={'homePage.under.1.desc'}/>
                    </p>
                </Flex>
            </Flex>

            <Flex style={{width: 300}} align={"center"} justify={"center"} gap={20}>
                <Image src={under2} preview={false} width={40}/>
                <Flex vertical align={"flex-start"} justify={"center"}>
                    <Flex gap={5} align={"flex-end"} justify={"center"}>
                        <span style={{color: clrs.orange, fontWeight: 700, transform: "translateY(-5px)", fontSize: "1.3rem"}}><IntlMessage id={'homePage.under.2.header1'}/></span>
                        <span style={{color: clrs.blacker, fontWeight: 700, fontSize: "2rem"}}><IntlMessage id={'homePage.under.2.header2'}/></span>
                    </Flex>
                    <p style={{fontWeight: 700, fontSize: "0.7rem", width: 240}}>
                        <IntlMessage id={'homePage.under.2.desc'}/>
                    </p>
                </Flex>
            </Flex>

            <Flex style={{width: 300}} align={"center"} justify={"center"} gap={20}>
                <Image src={under3} preview={false} width={40}/>
                <Flex vertical align={"flex-start"} justify={"center"}>
                    <Flex gap={5} align={"flex-end"} justify={"center"}>
                        <span style={{color: clrs.blacker, fontWeight: 700,  fontSize: "2rem"}}><IntlMessage id={'homePage.under.3.header1'}/></span>
                        <span style={{color: clrs.orange, fontWeight: 700, transform: "translateY(-5px)"}}><IntlMessage id={'homePage.under.3.header2'}/></span>
                    </Flex>
                    <p style={{fontWeight: 700, fontSize: "0.7rem", width: 240}}>
                        <IntlMessage id={'homePage.under.3.desc'}/>
                    </p>
                </Flex>
            </Flex>
        </Flex>
    )
}
export default HomePage;